import { Box } from '@hub/box';
import { CoreContainer } from '@hub/core-container';
import React from 'react';
import { HeaderNavigation } from './navigation';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderNavigationBar = _ref => {
  let {
    trigger,
    fadeDuration,
    primaryMenuItems,
    secondaryMenuItems,
    onOpen,
    onClickLink
  } = _ref;
  const [isOpenNavigation, setIsOpenNavigation] = React.useState(false);
  const handleOpenNavigation = React.useCallback(() => {
    setIsOpenNavigation(true);
    onOpen === null || onOpen === void 0 || onOpen();
  }, [onOpen]);
  const handleCloseNavigation = React.useCallback(() => {
    setIsOpenNavigation(false);
  }, []);
  if (!Array.isArray(primaryMenuItems)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    backgroundColor: "surfaceBrandSecondary",
    "data-id": "header-navigation-bar_index_HeaderNavigationBar_Box",
    children: /*#__PURE__*/_jsx(CoreContainer, {
      fadeOutOverflow: [true, true, null, false],
      "data-id": "header-navigation-bar_index_HeaderNavigationBar_Box_CoreContainer",
      children: /*#__PURE__*/_jsx(HeaderNavigation, {
        trigger: trigger,
        fadeDuration: fadeDuration,
        isOpen: isOpenNavigation,
        onClose: handleCloseNavigation,
        onOpen: handleOpenNavigation,
        primaryItems: primaryMenuItems,
        secondaryItems: secondaryMenuItems,
        onClickLink: onClickLink,
        "data-id": "header-navigation-bar_index_HeaderNavigationBar_CoreContainer_HeaderNavigation"
      })
    })
  });
};